var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4286 18.8039C72.5789 15.5425 96.7946 0 128.52 0C187.049 0 234.559 47.5162 234.559 106.039C234.559 144.157 214.402 177.601 184.18 196.287L191.272 176.804C202.762 145.235 186.461 110.274 154.893 98.7841C130.644 89.9541 104.396 97.5227 88.3175 115.817L78.4678 105.967C54.8731 82.307 51.5267 46.0391 68.4286 18.8039V18.8039Z",
    fill: "url(#paint0_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.879 93.9872C133.918 92.9676 143.33 93.9676 152.454 97.2878C160.755 100.314 168.003 104.955 173.964 110.732C157.931 119.745 147.088 136.928 147.088 156.615C147.088 159.909 147.389 163.124 147.964 166.249C131.827 154.922 121.265 136.17 121.265 114.974C121.265 107.615 122.539 100.556 124.879 93.9872V93.9872Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.936 6.95424C101.047 3.16993 113.844 0 128.178 0C186.707 0 234.217 47.5163 234.217 106.039C234.217 133.392 223.838 158.34 206.812 177.15C232.361 136.117 226.517 85.5816 220.295 72.3594C222.668 83.6339 220.295 89.1241 217.197 99.0195C202.446 6.95424 121.178 4.7647 90.936 6.95424V6.95424Z",
    fill: "url(#paint2_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.294 51.503C149.543 55.5161 158.346 55.5161 165.595 51.503C176.608 45.405 192.386 36.6664 198.85 33.0847C199.464 32.7449 200.209 32.7579 200.81 33.1109C201.412 33.4703 201.784 34.1174 201.784 34.8168C201.784 43.2808 201.784 65.6664 201.784 77.2873C201.784 81.9147 199.948 86.3526 196.667 89.6271C184.333 101.947 153.941 132.287 153.941 132.287C153.941 132.287 123.556 101.947 111.216 89.6271C107.941 86.3526 106.098 81.9147 106.098 77.2873C106.098 65.6664 106.098 43.2808 106.098 34.8168C106.098 34.1174 106.471 33.4703 107.072 33.1109C107.673 32.7579 108.425 32.7449 109.033 33.0847C115.497 36.6664 131.275 45.405 142.294 51.503Z",
    fill: "url(#paint3_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.855 32.8363C109.195 32.8363 109.535 32.9148 109.842 33.0847C116.306 36.6664 132.084 45.405 143.104 51.503C150.352 55.5161 159.156 55.5161 166.404 51.503L196.326 34.9344C185.581 43.954 166.953 53.4638 163.908 55.2939C165.836 56.6664 167.189 57.1958 168.365 58.4638C159.757 58.4638 141.679 59.3919 128.182 61.32C133.11 58.0586 139.718 56.2481 143.633 55.8952C132.999 52.3461 113.045 39.4442 108.855 32.8363V32.8363Z",
    fill: "url(#paint4_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.109 99.0201C145.275 99.0201 147.03 97.2644 147.03 95.0985C147.03 92.9327 145.275 91.177 143.109 91.177C140.943 91.177 139.187 92.9327 139.187 95.0985C139.187 97.2644 140.943 99.0201 143.109 99.0201Z",
    fill: "#521A87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.166 99.0201C167.332 99.0201 169.088 97.2644 169.088 95.0986C169.088 92.9327 167.332 91.177 165.166 91.177C163 91.177 161.244 92.9327 161.244 95.0986C161.244 97.2644 163 99.0201 165.166 99.0201Z",
    fill: "#521A87"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.7 127.078L159.386 126.83L153.896 132.287L148.7 127.078Z",
    fill: "#521A87"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.387 80.2149C106.576 80.2018 106.766 80.1953 106.962 80.1953C129.831 84.1038 147.459 103.431 148.766 127.078L111.256 89.6267C108.681 87.0515 106.995 83.7574 106.387 80.2149ZM201.77 79.9665C201.587 79.9534 201.391 79.9469 201.195 79.9469C178.332 83.8554 160.698 103.182 159.397 126.829L196.901 89.3783C199.476 86.8031 201.169 83.509 201.77 79.9665Z",
    fill: "url(#paint5_radial)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2544 198.621C83.7184 181.83 104.392 171.078 127.561 171.078C132.169 171.078 136.686 171.503 141.065 172.32C156.124 197.627 152.764 230.862 130.986 252.64C128.882 254.745 127.627 256 127.627 256L70.2544 198.621V198.621Z",
    fill: "url(#paint6_radial)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6601 198.621L53.0588 181.019H53.0849C33.8823 161.817 22 135.307 22 106.039C22 69.8235 40.1895 37.8236 67.928 18.6929L67.9411 18.804C51.0392 46.0392 54.3856 82.3071 77.9803 105.967L141.47 172.32C137.091 171.503 132.575 171.078 127.967 171.078C104.797 171.078 84.1241 181.83 70.6601 198.621V198.621Z",
    fill: "url(#paint7_radial)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.76 213.634C103.433 167.628 66.9492 136.961 56.5113 108.804L61.4916 134.621C32.2106 113.405 19.9819 56.5689 68.472 18.8369L68.4851 18.9545C51.5832 46.1898 54.9296 82.4512 78.5243 106.118L142.014 172.464C160.635 196.438 153.714 231.007 131.936 252.791L128.727 256C133.753 226.909 135.583 204.837 123.76 185.085C124.668 195.079 126.165 205.634 123.76 213.634Z",
    fill: "url(#paint8_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(232.049 0.000653008) rotate(-90.7334) scale(198.717 139.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F18727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A91B80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 176.109,
    y1: 155.066,
    x2: 125.531,
    y2: 104.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F18727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A91B80"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.579 16.885) rotate(145.687) scale(65.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCF8",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0CF16",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.167 33.7141) rotate(-135) scale(124.607 118.544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F18727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A91B80"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.634 35.554) rotate(169.812) scale(33.3035 12.4526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCF8",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0CF16",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.123 127.076) rotate(-131.625) scale(64.1659)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.817 172.743) rotate(98.3638) scale(84.1022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D8E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9196 81.8758) rotate(-89.5465) scale(146.813 130.885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F18727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A91B80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 137.241,
    y1: 171.739,
    x2: -33.8828,
    y2: -34.3159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFCF8",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0CF16",
    stopOpacity: 0.25
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.85c449ca959c3bc7b08a7e8ffd3e799f.svg";
export { ForwardRef as ReactComponent };